import InitComponent from "Modules/InitComponent";
import PhoneNumberCta from "./PhoneNumberCta.vue";
import PhoneNumberLink from "./PhoneNumberLink.vue";

const phoneNumberElements = document.getElementsByClassName(
  "lavendla-phone-number"
);
const initComponent = new InitComponent({
  components: { PhoneNumberLink },
  replaceHost: true,
  selectors: phoneNumberElements,
  template: "<PhoneNumberLink />",
});

initComponent.init();

const phoneNumberCtaElements = document.getElementsByClassName(
  "lavendla-phone-number-cta"
);
const initCtaComponent = new InitComponent({
  components: { PhoneNumberCta },
  replaceHost: true,
  selectors: phoneNumberCtaElements,
  template: "<PhoneNumberCta />",
});

initCtaComponent.init();
